export enum ColoredStatusComplaintsEnum {
  NEW = "is-info",
  DISPUTE_CALL_CENTER = "is-danger is-light",
  CALL_CENTER = "is-danger",
  NON_RELEVANT = "is-gray",
  TRAFFIC = "is-dark",
  CONSIDERATION = "is-warning"
}